import React from 'react';

import { Inline, type InlineProps } from '@atlaskit/primitives/compiled';

const defaultKnowledgeCardActionsProps = {
	alignBlock: 'center' as const,
	grow: 'fill' as const,
	space: 'space.100' as const,
};
export const KnowledgeCardActions = (props: InlineProps): React.JSX.Element => {
	const knowledgeCardActionsProps = {
		...defaultKnowledgeCardActionsProps,
		...props,
	};
	return <Inline {...knowledgeCardActionsProps} />;
};
